import { useContext } from 'react';

import { PieChartStateContext } from '../../context/PieChartStateContext.js';

export const useSetState = () => {
  const { setState } = useContext(PieChartStateContext);

  return setState;
};
